import { STORY_ROLES } from '../../../helpers'

// Pill color per relation_type_code — matches the design mockup's palette
// exactly (salj=blue, leverans=green, rekrytering=purple, talare=gold,
// alumni=grey, partner=pink). Shared by PersonList and PersonDetail so the
// two never drift. talare/deltagare's color is defined once in the shared
// storyRoles helper (also consumed by kayentaStories' Participants.js) and
// just spread in here, so the two never drift from each other either.
export const relationTypeClass = {
  salj: 'pill pill-blue',
  leverans: 'pill pill-green',
  rekrytering: 'pill pill-purple',
  talare: STORY_ROLES.speaker.pillClassName,
  alumni: 'pill pill-grey',
  partner: 'pill pill-pink',
  deltagare: STORY_ROLES.participant.pillClassName,
}
